import React, { ReactNode, useState } from 'react';
import { Menu } from '@headlessui/react';

interface MenuItemCustomProps {
  name: string;
  icon: ReactNode;
  divMenu?: boolean;
  type?:string;
  selectedHandler: () => void;
}

const MenuItemCustom: React.FC<MenuItemCustomProps> = ({ name, icon, divMenu, type, selectedHandler }) => {
  return (
    <>
      {divMenu != undefined && divMenu ? (
        <>
          <div
            className="w-full cursor-pointer pl-3-1 pr-2-1 py-2-1 gap-2-1 hover:bg-gray-100"
            onClick={(event: React.MouseEvent) => {
              // event.preventDefault();
              selectedHandler();
            }}
          >
            <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
              {icon}
              <div className="font-medium text-sm">{name}</div>
            </div>
          </div>
        </>
      ) : (
        <>
          <Menu.Item>
            {({ active }) => (
              <div
                className={"w-full cursor-pointer pl-3-1 pr-2-1 py-2-1 gap-2-1 " +
                  (type && type == 'button-primary' ? ' bg-blue-500 text-white ' : ' hover:bg-gray-100 ')
                }
                onClick={(event: React.MouseEvent) => {
                  // event.preventDefault();
                  selectedHandler();
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  {icon}
                  <div className="font-medium text-sm">{name}</div>
                </div>
              </div>

            )}
          </Menu.Item>
        </>
      )}
    </>
  );
};

export default MenuItemCustom;
